import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { getVodURL, postLog, postDeploy, getAdminVodURL } from "../apis/VodApi";

export const getVodURLThunk = createAsyncThunk("VOD/get", getVodURL); // 동영상 url 가져오기
export const postLogThunk = createAsyncThunk("VOD/post", postLog); // LOG 저장하기
export const getAdminVodURLThunk = createAsyncThunk(
  "Admin/get",
  getAdminVodURL
); //관리자 - 동영상 url 가져오기
export const postDeployThunk = createAsyncThunk("Deploy/post", postDeploy); //영상 배포하기

const vodStore = createSlice({
  name: "vodStore",
  initialState: {
    loading: false,
    url: "",
    kwamok: "",
    fileNM: "",
    error: null,
    admin: null, //관리자 화면-검수(Y), 사용자 화면-QR(N) 구분용 변수
    deploy: null, //관리자 화면 - 배포하기 버튼 (/admin/check)
    idx: null, //관리자 화면 - 영상 idx 변수
  },
  reducers: {
    setAdminThunk(state, { payload }) {
      state.admin = payload;
    },
    setDeployThunk(state, { payload }) {
      state.deploy = payload;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(getVodURLThunk.pending, (state) => {
        state.loading = true;
      })
      .addCase(getVodURLThunk.fulfilled, (state, action) => {
        //[{"FileNM":"KE_AZ_0000_01_000026.mp4"}]
        state.loading = false;
        //console.log(" [ payload ] : ", action.payload);
        //console.log(" [ payload ] : ", action.payload[0].VodPath," / ", action.payload[0].FileNM);
        action.payload[0] === undefined
          ? (state.error = "** getVodURL error **")
          : (state.url = action.payload[0].VodPath);
      })
      .addCase(getVodURLThunk.rejected, (state, { error }) => {
        state.loading = false;
        state.error = error;
      })
      .addCase(getAdminVodURLThunk.pending, (state) => {
        state.loading = true;
      })
      .addCase(getAdminVodURLThunk.fulfilled, (state, action) => {
        state.loading = false;
        //console.log(" [ payload ] : ", action.payload);
        //console.log(" [ payload ] : ", action.payload[0].VodPath," / ", action.payload[0].FileNM);
        action.payload[0] === undefined
          ? (state.error = "** getAdminVodURL error **")
          : (state.url = action.payload[0].VodPath);
        action.payload[0] === undefined
          ? (state.error = "** getAdminVodURL error **")
          : (state.kwamok = action.payload[0].Kwamok);
        action.payload[0] === undefined
          ? (state.error = "** getAdminVodURL error **")
          : (state.fileNM = action.payload[0].FileNM);
        action.payload[0] === undefined
          ? (state.error = "** getAdminVodURL error **")
          : (state.idx = action.payload[0].idx);
      })
      .addCase(getAdminVodURLThunk.rejected, (state, { error }) => {
        state.loading = false;
        state.error = error;
      })
      .addCase(postLogThunk.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(postLogThunk.fulfilled, (state) => {
        state.loading = false;
      })
      .addCase(postLogThunk.rejected, (state, { error }) => {
        state.loading = false;
        state.error = error;
      })
      .addCase(postDeployThunk.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(postDeployThunk.fulfilled, (state) => {
        state.loading = false;
      })
      .addCase(postDeployThunk.rejected, (state, { error }) => {
        state.loading = false;
        state.error = error;
      });
  },
});

export const { setAdminThunk, setDeployThunk } = vodStore.actions;

export default vodStore.reducer;
